<template>
  <form
    :action="action"
    method="post"
  >
    <slot />
    <input
      :value="purchaseOrderId"
      name="purchase_order_id"
      type="hidden"
    >
    <input
      :value="authenticationToken"
      name="token"
      type="hidden"
    >
    <input
      :value="userEmail"
      name="email"
      type="hidden"
    >
    <input
      name="source"
      value="wux"
      type="hidden"
    >
    <input
      name="sc"
      class="sc-input"
      :value="sc"
      type="hidden"
    >
    <input
      name="partner_ref"
      class="partner-ref-input"
      :value="partnerRef"
      type="hidden"
    >
  </form>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: '',
    },
    partnerRef: {
      type: String,
      default: '',
    },
    purchaseOrder: {
      type: Object,
      default: () => ({}),
    },
    sc: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    purchaseOrderId() {
      return this.purchaseOrder?.id || '';
    },
    authenticationToken() {
      return this.user?.authenticationToken || '';
    },
    userEmail() {
      return this.user?.email || '';
    },
  },
};
</script>
